<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="['update', 'create'].includes(formProps.editType)"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >{{ formProps.editType === 'create' ? '新增隐患' : '编辑隐患' }}</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="隐患详情"> </el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="隐患基本信息" name="baseInfo">
            <HiddenInfo :FormData="formData"></HiddenInfo>
          </el-collapse-item>
          <el-collapse-item title="隐患审核" name="verify">
            <HiddenOk :FormData="formData"></HiddenOk>
          </el-collapse-item>
          <el-collapse-item title="隐患整改" name="rectification">
            <HiddenRectificationView :FormData="formData"></HiddenRectificationView>
          </el-collapse-item>
          <!-- <el-collapse-item title="隐患整改延期" name="postpone" v-if="true">
            <el-form
              ref="planForm"
              label-width="150px"
              :model="planForm"
              v-loading="loading"
              :disabled="formProps.editType === 'read'"
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="隐患整改延期申请人"
                    prop="planHeadControlId1"
                    ref="planHeadControlId1"
                  >
                    <el-input
                      v-model="formData.planHeadControlId1"
                      placeholder="请输入隐患整改延期申请人"
                      maxlength="100"
                      show-word-limit
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item label="整改延期申请时间" prop="OccurTime">
                    <el-date-picker
                      size="small"
                      v-model="formData.OccurTime"
                      class="!w-full"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="请输入整改延期申请时间"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item label="延期整改完成时间" prop="affiliationOrg">
                    <el-date-picker
                      size="small"
                      v-model="formData.affiliationOrg"
                      class="!w-full"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="请输入延期整改完成时间"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item label="隐患整改延期原因" prop="category">
                    <el-input
                      v-model="formData.category"
                      placeholder="请输入隐患整改延期原因"
                      maxlength="100"
                      show-word-limit
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item> -->
          <el-collapse-item title="隐患整改延期" name="postpone" v-if="showPostpone">
            <HiddenPostponeView :FormData="formData"></HiddenPostponeView>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button type="primary" size="small" @click="handleAccept(true)" :loading="loading"
          >验收通过</el-button
        >
        <el-button type="danger" size="small" @click="handleAccept(false)" :loading="loading"
          >验收不通过</el-button
        >
        <el-button @click="goBack" size="small">取消</el-button>
      </div>
    </div>
    <AcceptForm
      v-if="showDialog"
      :loading="loading"
      :taskId="formData.id"
      @handleOk="handleOk"
      @cancel="showDialog = false"
    ></AcceptForm>
  </el-card>
</template>

<script>
import uuid from 'uuid'

import dayjs from 'dayjs'

import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import HiddenInfo from '../business/HiddenInfo'
import HiddenOk from '../business/HiddenOk'
import HiddenRectificationView from '../business/HiddenRectificationView'
import AcceptForm from './AcceptForm'
import HiddenPostponeView from '../business/HiddenPostponeView'

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

const areaApi = new AreaApi()

export default {
  name: 'hidden-accept-form',
  components: {
    HiddenOk,
    HiddenInfo,
    AcceptForm,
    HiddenRectificationView,
    HiddenPostponeView,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      isPass: true,
      showDelayForm: false,
      showForm: false,
      showDialog: false,
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      riskLevelList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      formData: {},
      loading: false,
      rules: {},
      collapseActiveName: ['baseInfo', 'verify', 'rectification', 'postpone'],
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal))
        } else {
          this.formData = {}
        }
      },
      immediate: true,
    },
  },
  computed: {
    showPostpone() {
      return (
        this.formData.hiddenDangerRectificationExtensionApplicantId ||
        this.formData.hiddenDangerRectificationExtensionApplicationTime ||
        this.formData.deferralTime ||
        this.formData.hiddenDangersRectificationDelayReason
      )
    },
  },
  created() {
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
      ],
      ['hiddenLevelList', 'hiddenTypeList', 'hiddenCategoryList'],
      this
    )
  },
  mounted() {},

  methods: {
    goBack() {
      if (this.formProps.editType === 'approve') {
        this.$router.go(-1)
      }
      this.$emit('cancel')
    },
    handleAccept(isPass) {
      this.isPass = isPass
      this.showDialog = true
    },
    async handleOk(reason) {
      this.loading = true
      let data = { id: this.formData.id }
      if (this.isPass) {
        data.body = {
          acceptanceOpinions: reason,
          currentWorkflowTaskId: this.formData.currentWorkflowTaskId,
        }
      } else {
        data = {
          body: {
            id: this.formData.id,
            currentWorkflowTaskId: this.formData.currentWorkflowTaskId,
            rejectionReasons: reason,
          },
        }
      }
      const apiKey = this.isPass ? 'hiddenDangersAcceptance' : 'hiddenDangersAcceptanceOverrule'
      const [err, res] = await hiddenDangerRectificationChecklistApi[apiKey](data)
      if (!err) {
        this.$message({
          showClose: true,
          message: this.isPass ? '验收通过' : '验收不通过',
          type: 'success',
        })
        if (this.formProps.editType === 'approve') {
          this.$router.go(-1)
        }
        this.$emit('refreshList')
        this.$emit('cancel')
      }
      this.loading = false
      this.showDialog = false
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    validatorPerson(rule, value, callback) {
      if (!value) {
        callback(new Error(rule.message))
      }
      if (this.formData.planHeadControlId1 === this.formData.planHeadControlId2) {
        callback(new Error('隐患整改负责人和隐患验收负责人不能是同一人!'))
        return
      }
      callback()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
